import { makeStateKey } from '@angular/core';

/**
 * Key used to track if the application was fully initialized on the server.
 * This helps the client-side AppComponent start in 'ready' state during hydration.
 */
export const APP_INITIALIZED_KEY = makeStateKey<boolean>('app_initialized');
